// extracted by mini-css-extract-plugin
export default {"defs":"AiIconGradient_defs__yH1U7"};